import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import LoadingButton from '@atlaskit/button/loading-button';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const PrimaryCTAContainer = _styled("div", {
  target: "eewegni0",
  label: "PrimaryCTAContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "17gow3k",
  styles: "min-width:106px;"
} : {
  name: "17gow3k",
  styles: "min-width:106px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
export default class PrimaryCTA extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "render", () => /*#__PURE__*/_jsx(PrimaryCTAContainer, {
      children: /*#__PURE__*/_jsx(LoadingButton, {
        appearance: "primary",
        href: this.props.href,
        isLoading: this.props.isLoading,
        isDisabled: this.props.isDisabled,
        onClick: this.props.onClick,
        shouldFitContainer: true,
        id: this.props.buttonId,
        testId: this.props.testId,
        children: this.props.children
      })
    }));
  }
}
_defineProperty(PrimaryCTA, "propTypes", {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func
});
_defineProperty(PrimaryCTA, "defaultProps", {
  isDisabled: false,
  isLoading: false
});